import { Box, Drawer, List, Toolbar } from '@mui/material';
import { Menu } from '@mui/icons-material';

import { imgSmartNurseLogoText } from 'assets';

import { MAIN_TOP_BAR_HEIGHT } from '../MainTopBar';
import { StyledDrawerWrapper } from '../style';
import CopyRight from './CopyRight';
import MenuRecords from './MenuRecords';
import MenuSettings from './MenuSettings';

import useUser from 'store/user/useUser';
import MenuProfessor from './MenuProfessor';

interface Props {
  name?: string;
  college_ci?: string;
  college_name?: string;
  menuDrawerWidth: number;
  setMenuDrawerWidth: (menuDrawerWidth: number) => void;
  coachRefA: any;
  coachRefB: any;
  isDesktopLayout: boolean;
  mobileOpen: boolean;
  onMobileClose: () => void;
}

const MenuDrawer = (props: Props) => {
  const {
    name,
    college_ci,
    college_name,
    menuDrawerWidth,
    setMenuDrawerWidth,
    coachRefA,
    coachRefB,
    isDesktopLayout,
    mobileOpen,
    onMobileClose,
  } = props;

  const { isStudent } = useUser();
  const drawerWidth = isDesktopLayout ? menuDrawerWidth : 220;

  const mobileDrawerOffset = {
    top: MAIN_TOP_BAR_HEIGHT,
    height: `calc(100% - ${MAIN_TOP_BAR_HEIGHT}px)`,
  };

  const handleDesktopMenuToggle = () => {
    setMenuDrawerWidth(menuDrawerWidth === 220 ? 52 : 220);
  };

  return (
    <Drawer
      open={isDesktopLayout ? true : mobileOpen}
      variant={isDesktopLayout ? 'permanent' : 'temporary'}
      onClose={onMobileClose}
      ModalProps={{ keepMounted: true }}
      sx={{
        width: isDesktopLayout ? menuDrawerWidth : 0,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          ...(isDesktopLayout ? {} : mobileDrawerOffset),
        },
      }}
      PaperProps={{
        sx: {
          width: drawerWidth,
          ...(isDesktopLayout ? {} : mobileDrawerOffset),
        },
      }}
    >
      <StyledDrawerWrapper>
        {isDesktopLayout && (
          <Toolbar>
            {menuDrawerWidth === 220 ? (
              <Box
                height={35}
                component="img"
                alt={college_name ? college_name : 'SmartNurse'}
                src={college_ci ? college_ci : imgSmartNurseLogoText}
                sx={{ objectFit: 'contain' }}
              />
            ) : null}
          </Toolbar>
        )}
        <Box className="userDiv">
          {isDesktopLayout && (
            <Menu className="hamburgerIcon" onClick={handleDesktopMenuToggle} />
          )}
          {(isDesktopLayout ? menuDrawerWidth === 220 : true) && name}
        </Box>

        <List ref={coachRefA}>
          {isStudent ? null : (
            <>
              <MenuProfessor
                menuDrawerWidth={menuDrawerWidth}
                setMenuDrawerWidth={setMenuDrawerWidth}
              />
              <Box sx={{ mt: '30px' }} />
            </>
          )}
          <MenuRecords
            menuDrawerWidth={menuDrawerWidth}
            setMenuDrawerWidth={setMenuDrawerWidth}
            coachRef={coachRefB}
          />
          <Box sx={{ mt: '90px' }} />
          <MenuSettings
            menuDrawerWidth={menuDrawerWidth}
            setMenuDrawerWidth={setMenuDrawerWidth}
          />
          <CopyRight />
        </List>
      </StyledDrawerWrapper>
    </Drawer>
  );
};

export default MenuDrawer;
